import { useEffect, useState, useCallback } from "react";
import api, { apiError, API } from "../lib/api";
import { fmtIDR } from "../lib/format";
import { FileSpreadsheet, FileText, Loader2 } from "lucide-react";
import { toast } from "sonner";

const RANGES = [{ k: "today", l: "Harian" }, { k: "week", l: "Mingguan" }, { k: "month", l: "Bulanan" }];

export default function Reports() {
  const [range, setRange] = useState("today");
  const [rep, setRep] = useState(null);
  const [exporting, setExporting] = useState("");

  const load = useCallback(() => {
    api.get(`/reports?range=${range}`).then((r) => setRep(r.data)).catch((e) => toast.error(apiError(e)));
  }, [range]);
  useEffect(load, [load]);

  const doExport = async (format) => {
    setExporting(format);
    try {
      const res = await api.get(`/reports/export?format=${format}&range=${range}`, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url; a.download = `nnx_report_${range}.${format === "excel" ? "xlsx" : "pdf"}`; a.click();
      URL.revokeObjectURL(url);
      toast.success(`Export ${format} berhasil`);
    } catch (e) { toast.error(apiError(e)); } finally { setExporting(""); }
  };

  const s = rep?.summary;
  return (
    <div className="space-y-4">
      <h1 className="font-head text-2xl font-bold">Reports</h1>

      <div className="flex flex-wrap items-center gap-2 justify-between">
        <div className="flex gap-2">
          {RANGES.map((r) => (
            <button key={r.k} data-testid={`report-range-${r.k}`} onClick={() => setRange(r.k)}
              className={`chip ${range === r.k ? "bg-[#EAB308] text-[#0B0E14] border-[#EAB308]" : ""}`}>{r.l}</button>
          ))}
        </div>
        <div className="flex gap-2">
          <button className="btn-outline flex items-center gap-2" data-testid="export-excel" onClick={() => doExport("excel")} disabled={exporting}>
            {exporting === "excel" ? <Loader2 className="h-4 w-4 animate-spin" /> : <FileSpreadsheet className="h-4 w-4" />} Excel
          </button>
          <button className="btn-outline flex items-center gap-2" data-testid="export-pdf" onClick={() => doExport("pdf")} disabled={exporting}>
            {exporting === "pdf" ? <Loader2 className="h-4 w-4 animate-spin" /> : <FileText className="h-4 w-4" />} PDF
          </button>
        </div>
      </div>

      {s && (
        <>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
            <Metric label="Transaksi" value={s.count} />
            <Metric label="Volume" value={fmtIDR(s.volume)} />
            <Metric label="Buy Volume" value={fmtIDR(s.buy_volume)} />
            <Metric label="Sell Volume" value={fmtIDR(s.sell_volume)} />
            <Metric label="Exchange Volume" value={fmtIDR(s.exchange_volume)} />
            <Metric label="Profit Kotor" value={fmtIDR(s.gross_profit)} accent />
            <Metric label="Fees" value={fmtIDR(s.fees)} />
            <Metric label="Expenses" value={fmtIDR(rep.expenses)} />
          </div>
          <div className="nnx-card p-5">
            <div className="flex items-center justify-between">
              <span className="label">Net Profit (setelah expenses)</span>
              <span className="mono font-bold text-2xl text-[#EAB308]" data-testid="report-net">{fmtIDR(rep.net_after_expenses)}</span>
            </div>
          </div>
          <div className="nnx-card p-4">
            <div className="label mb-3">Profit per Officer</div>
            {Object.keys(rep.profit_by_officer).length === 0 ? <div className="text-sm text-[#64748B]">Belum ada data.</div> :
              Object.entries(rep.profit_by_officer).map(([o, p]) => (
                <div key={o} className="flex justify-between text-sm py-1.5 border-b border-[#222B3D]/60"><span>{o}</span><span className="mono text-emerald-400">{fmtIDR(p)}</span></div>
              ))}
          </div>
        </>
      )}
    </div>
  );
}

function Metric({ label, value, accent }) {
  return (
    <div className="nnx-card p-4">
      <div className="label">{label}</div>
      <div className={`mono font-bold text-lg mt-1 ${accent ? "text-[#EAB308]" : "text-white"}`}>{value}</div>
    </div>
  );
}
